<template>
  <paginated-table
    ref="table"
    endpoint="communityFriends"
    :sync-filters-with-url="syncFiltersWithUrl"
    :columns="columns"
    :load-relations="extraRelations"
    :extra-filters="extraFilters"
    v-bind="$attrs"
    :show-action-column="isGlobalAdmin"
    @filters-changed="updateFilters"
  >
    <template #head><slot name="head"></slot></template>
    <template #head-buttons><slot name="head-buttons"></slot></template>

    <template #cell(actions)="{ item }">
      <admin-list-actions
        :show-restore="false"
        :item="item"
        :item-name="$t('components.community.community_friends_list.the_friend_community')"
        slug="friends"
        :destroy-action="() => deleteCommunityFriend(item)"
        archive-label="supprimer"
      />
    </template>
  </paginated-table>
</template>

<script>
import AdminListActions from "@/components/Admin/ListActions.vue";
import PaginatedTable from "@/components/shared/PaginatedTable.vue";
import { Column } from "@/components/shared/PaginatedTableColumns";
import { capitalize } from "@/helpers/filters";
import { isGlobalAdmin } from "@/helpers/permissions/users";

export default {
  name: "CommunityFriendsList",
  components: {
    AdminListActions,
    PaginatedTable,
  },
  props: {
    hideFields: {
      type: Array,
      required: false,
      default: () => [],
    },
    syncFiltersWithUrl: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    const defaultColumns = [
      new Column("id", capitalize(this.$t("lists.id")), "id", { showByDefault: false }),
      new Column("community_id", capitalize(this.$t("communities.fields.community.id")), "id", {
        showByDefault: false,
        urlFct: (item) => `/admin/communities/${item.community_id}`,
      }),
      Column.withRelation(
        "community.name",
        capitalize(this.$t("communities.fields.community.name")),
        {
          relation: "communities",
          label: "name",
          field: "id",
        },
        "community_id",
        {
          urlFct: (item) => `/admin/communities/${item.community_id}`,
        }
      ),
      new Column("friend_id", capitalize(this.$t("communities.fields.friend.id")), "id", {
        showByDefault: false,
        urlFct: (item) => `/admin/communities/${item.friend_id}`,
      }),
      Column.withRelation(
        "friend.name",
        capitalize(this.$t("communities.fields.friend.name")),
        {
          relation: "communities",
          label: "name",
          field: "id",
        },
        "community_id",
        {
          urlFct: (item) => `/admin/communities/${item.friend_id}`,
        }
      ),
    ];

    const extraRelations = [];

    const extraFilters = [];

    return {
      defaultColumns,
      extraRelations,
      filters: {},
      extraFilters,
    };
  },
  computed: {
    columns() {
      return this.defaultColumns.filter((c) => !this.hideFields.includes(c.key));
    },
    isGlobalAdmin() {
      return isGlobalAdmin(this.$store.state.user);
    },
  },
  methods: {
    capitalize,
    async deleteCommunityFriend(item) {
      if (!item) {
        return;
      }

      await this.$store.dispatch(`communities/removeFriend`, {
        communityId: item.community_id,
        friendId: item.friend_id,
      });

      this.refresh();
    },
    refresh() {
      this.$refs.table.refresh();
    },
    setFilters(filters) {
      this.$refs.table.setFilters(filters);
    },
    updateFilters(filters) {
      this.filters = Object.assign({}, filters);
    },
  },
};
</script>

<style lang="scss"></style>
